import { API_VERSION } from "@shared/constants";

const AUTH_BASE_URL = `${API_VERSION}/auth`;

export const LOGIN_URL = `${AUTH_BASE_URL}/login`;
export const LOGOUT_URL = `${AUTH_BASE_URL}/logout`;
